/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import * as React from "react";
import {
  MenuItem,
  Grid,
  Select,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { KeyboardArrowDown } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  selectGrid: {
    marginBottom: theme.spacing(2),
  },
  select: {
    boxShadow: "0px 2px 4px 1px #d9d9d9",
    height: "40px",
    borderRadius: "5px",
    marginBottom: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    fontFamily: "Telegraf-Regular",
  },
  inputLabel: {
    [theme.breakpoints.up("md")]: {
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(2),
      textAlign: "right",
    },
  },
}));

export const QuestionnaireSelectInput = (props) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.selectGrid}>
      <Grid item xs={12} md={5}>
        <Typography
          className={classes.inputLabel}
          key={`question-label-${props.question.source}`}
          variant="body1"
        >
          {props.question.label}
        </Typography>
      </Grid>
      <Grid item xs={12} md={5}>
        <Select
          displayEmpty
          fullWidth
          disableUnderline
          inputProps={{ "data-testid": `test-input-${props.question.source}` }}
          value={props.answersForQuestions[props.question.source]}
          onChange={(event) => {
            props.onSelect(props.question.source, event.target.value);
          }}
          IconComponent={KeyboardArrowDown}
          className={classes.select}
          renderValue={(value) => {
            if (value) {
              const selectedOption = props.question.options.find(
                (option) => option.id === value
              );
              return selectedOption.name ?? "Select";
            }
            return "Select";
          }}
        >
          {props.question.options.map((option) => (
            <MenuItem key={`menu-item-${option.id}`} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      </Grid>
    </Grid>
  );
};
